"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureTag = void 0;
exports.featureTag = [
    {
        name: 'Android Auto',
        category: 'Technology',
        regex: /(?=^.*android)/i,
        start_year: 2014,
    },
    {
        name: 'Apple CarPlay',
        category: 'Technology',
        regex: /(?=^.*apple)(?=^.*car play)/i,
        start_year: 2014,
    },
    {
        name: 'Backup Camera',
        category: 'Safety',
        regex: /(((?=^.*back?[ -]?up)|(?=^.*rear)|(?=^.*reversing)|(?=^.*around))(?=^.*camera))|rear?[ -]?view.*monitor/i,
        start_year: 2007,
    },
    {
        name: 'Blind Spot Monitor',
        category: 'Safety',
        regex: /(?=^.*blind.spot)((?=^.*display)|(?=^.*camera)|(?=^.*alert)|(?=^.*blind.spot)|(?=^.*safety))|autopilot|(?=^.*side)(?=^.*camera)/i,
        start_year: 2007
    },
    {
        name: 'Collision Avoidance',
        category: 'Safety',
        regex: /(?=^.*collision)((?=^.*pre-)|(?=^.*warning)|(?=^.*avoidance)|(?=^.*notif))|pre?[ -]?sense|driving.assistant|emergency.braking|pre?[ -]?safe|eyesight|autopilot/i,
        start_year: 1996
    },
    {
        name: 'Lane Departure Warning',
        category: 'Safety',
        regex: /(?=^.*lane)((?=^.*departure)|(?=^.*deviation)|(?=^.*assist)|(?=^.*keep))|autopilot/i,
        start_year: 2002
    },
    {
        name: 'Lane Keeping Assistance',
        category: 'Safety',
        regex: /(?=^.*lane)|(?=^.*keeping)|autopilot/i,
        start_year: 2002
    },
    {
        name: 'Adaptive Cruise Control',
        category: 'Convenience',
        regex: /((?=^.*adaptive)|(?=^.*adaptive stop and go)|(?=^.*active)|(?=^.*dynamic)|(?=^.*radar)|(?=^.*intelligent)|(?=^.*traffic?[ -]?aware))(?=^.*cruise)|autopilot /i,
        start_year: 2010
    },
    {
        name: 'Parking Sensors',
        category: 'Convenience',
        regex: /park.*sensor/i,
        start_year: 1983
    },
    {
        name: 'Night View',
        category: 'Safety',
        regex: /(night\s+view)|(night\s+vision)/i,
        start_year: 2003
    },
    {
        name: 'Tire Pressure Monitoring',
        category: 'Safety',
        regex: /tire.*monitor/i,
        start_year: 1986
    },
    {
        name: 'Head-Up Display',
        category: 'Convenience',
        regex: /heads?[ -]?up[ ]?display|HUD/i,
        start_year: 1988
    },
    {
        name: 'Heated Mirrors',
        category: 'Exterior',
        regex: /(?=^.*heat)(?=^.*mirror)/i,
        start_year: 1900
    },
    {
        name: 'Rain Sensing Wipers',
        category: 'Convenience',
        regex: /(?=^.*rain)(?=^.*sens)(?=^.*wiper)/i,
        start_year: 1950
    },
    {
        name: 'Automatic Climate Control',
        category: 'Convenience',
        regex: /((?=^.*climate)|(?=^.*temperature))(?=^.*auto)/i,
        start_year: 1960
    },
    {
        name: 'Power Sliding Doors',
        category: 'Convenience',
        regex: /(?=^.*power)(?=^.*sliding)(?=^.*door)/i,
        start_year: 1960
    },
    {
        name: 'Remote Start',
        category: 'Convenience',
        regex: /(?=^.*remote)(?=^.*start)/i,
        start_year: 1968
    },
    {
        name: 'Push-Button Start',
        category: 'Convenience',
        regex: /(?=^.*push)(?=^.*start)|key?[ -]?less go|smart[ ]key/i,
        start_year: 1997
    },
    {
        name: 'Keyless Entry',
        category: 'Convenience',
        regex: /((?=^.*keyless)|(?=^.*passive)|(?=^.*smart)|(?=^.*proximity)|(?=^.*keypad))((?=^.*entry)|(?=^.*access)|(?=^.*unlock))|key?[ -]?less[ ]go/i,
        start_year: 1997
    },
    {
        name: 'Cross Traffic Alert',
        category: 'Safety',
        regex: /cross traffic/i,
        start_year: 1900
    },
    {
        name: 'Bluetooth',
        category: 'Entertainment',
        regex: /bluetooth/i,
        start_year: 2001
    },
    {
        name: 'Navigation',
        category: 'Technology',
        regex: /(?=^.*navigation)(?!^.*optional)(?!^.*if.equipped)/i,
        start_year: 1995
    },
    {
        name: 'Premium Audio',
        category: 'Entertainment',
        regex: /(?=^.*premium)((?=^.*speaker)|(?=^.*audio)|(?=^.*sound)|(?=^.*brand)|(?=^.*krell))|musicgate.*sound|1[0-9].speaker|surround.sound|(?=^.*speakers:)((?=^.[7-9])|(?=^.*[1-3][0-9]))/i,
        start_year: 1900
    },
    {
        name: 'Satellite Radio',
        category: 'Entertainment',
        regex: /satellite.*radio|sirius/i,
        start_year: 2004
    },
    {
        name: '115V Power Outlet',
        category: 'Convenience',
        regex: /(?=^.*115v)(?=^.*outlet)/i,
        start_year: 1900
    },
    {
        name: 'Leather Seats',
        category: 'Seating',
        regex: /(?=^.*leather)((?=^.*seat)|(?=^.*chair))/i,
        start_year: 1900
    },
    {
        name: 'Heated Seats',
        category: 'Seating',
        regex: /(?=^.*heat)(?=^.*seat)/i,
        start_year: 1966
    },
    {
        name: 'Cooled Seats',
        category: 'Seating',
        regex: /(?=^.*cool)(?=^.*seat)/i,
        start_year: 2007
    },
    {
        name: 'Ventilated Seats',
        category: 'Seating',
        regex: /(?=^.*ventilated)(?=^.*seat)/i,
        start_year: 2007
    },
    {
        name: 'Memory Seats',
        category: 'Seating',
        regex: /(?=^.*memory)(?=^.*seat)/i,
        start_year: 1993
    },
    {
        name: 'Power Seats',
        category: 'Seating',
        regex: /(?=^.*power)(?=^.*seat)/i,
        start_year: 1950
    },
    {
        name: 'Premium Wheels',
        category: 'Exterior',
        regex: /(?=^.*premium)(?=^.*wheel)/i,
        start_year: 1900
    },
    {
        name: 'Sunroof/Moonroof',
        category: 'Exterior',
        regex: /sunroof|moonroof|(?=^.*panoramic)(?=^.*roof)/i,
        start_year: 1900
    },
    {
        name: 'Tinted Windows',
        category: 'Exterior',
        regex: /((?=^.*window)|(?=^.*glass))((?=^.*privacy)|(?=^.*tint))/i,
        start_year: 1900
    },
    {
        name: 'Garage Door Opener',
        category: 'Convenience',
        regex: /garage?[ -]?door|homelink/i,
        start_year: 1900
    },
    {
        name: 'Adjustable Pedals',
        category: 'Convenience',
        regex: /adjustable.*pedals/i
    },
    {
        name: 'Towing Package',
        category: 'Convenience',
        regex: /towing.*package/i
    },
    {
        name: 'Driving Assistant',
        category: 'Safety',
        regex: /(?=^.*assistant)(?=^.*driving)/i
    },
    {
        name: 'Autonomous Driving',
        category: 'Convenience',
        regex: /(?=^.*autonomous)(?=^.*driving)/i
    },
    {
        name: 'Surround View',
        category: 'Safety',
        regex: /(?=^.*surround)(?=^.*view)/i
    },
    {
        name: 'Autonomous Braking',
        category: 'Safety',
        regex: /((?=^.*automatic)|(?=^.*autonomous))(?=^.*braking)/i,
        start_year: 2010
    },
    {
        name: 'Remote Parking Assist',
        category: 'Convenience',
        regex: /(?=^.*parking)(?=^.*assist)/i,
        start_year: 2016
    },
    {
        name: 'Exit Safety System',
        category: 'Safety',
        regex: /(?=^.*exit)(?=^.*safety)/i
    },
];
